<template>
  <!--
大框：K线图和时分图  style="height:100%;overflow:hidden;"
-->
  <div class="z-main">
	<!-- 头部数据 z-common-header z-flex-->
	<header class="z-header">
	  <div>
		<router-link :to="'/'+$route.query.from">
		  <img class="hearIcon" src="../../assets/sysbars/left.png">
		</router-link>
	  </div>
	  <div v-text="stockName" style="color:#E2B96F;"></div>
	  <div class="z-flex">
	  	<svg @click="reload()" t="1605254114755" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4099" width="22" height="22"><path d="M908.213073 209.095805l-56.344975 44.056975C775.043122 154.948683 655.559805 91.910244 521.390829 91.910244 289.717073 91.910244 102.200195 279.227317 101.900488 511.000976 101.60078 742.974439 289.517268 931.090732 521.390829 931.090732c181.123122 0 335.47239-114.887805 394.215025-275.830634 1.498537-4.195902-0.699317-8.891317-4.89522-10.289952l-56.644683-19.480975c-4.096-1.398634-8.59161 0.699317-10.090146 4.795317-1.798244 4.995122-3.796293 9.990244-5.894244 14.885463-17.283122 40.96-42.058927 77.724098-73.628098 109.293269-31.569171 31.569171-68.333268 56.344976-109.193365 73.728-42.258732 17.882537-87.314732 26.973659-133.669464 26.973658-46.454634 0-91.410732-9.091122-133.669463-26.973658-40.860098-17.283122-77.624195-42.058927-109.193366-73.728-31.569171-31.569171-56.344976-68.333268-73.628098-109.293269-17.882537-42.358634-26.973659-87.314732-26.973658-133.769366s9.091122-91.410732 26.973658-133.769365c17.283122-40.96 42.058927-77.724098 73.628098-109.293269 31.569171-31.569171 68.333268-56.344976 109.193366-73.728 42.258732-17.882537 87.314732-26.973659 133.669463-26.973658 46.454634 0 91.410732 9.091122 133.669464 26.973658 40.860098 17.283122 77.624195 42.058927 109.193365 73.728 9.890341 9.890341 19.181268 20.380098 27.772878 31.369366l-60.141268 46.954146c-5.294829 4.096-3.496585 12.487805 2.997073 14.086244l175.428683 42.958049c4.995122 1.198829 9.890341-2.597463 9.890342-7.692488l0.799219-180.723512c-0.099902-6.593561-7.79239-10.289951-12.987317-6.193951z" p-id="4100" fill="#2c2c2c"></path></svg>
	  	&nbsp;&nbsp;&nbsp;&nbsp;
		<router-link :to="getToken()==''?'/login': {path:'/futures/transaction',query:$route.query}">
		  <span class="dark-color">{{$t('交易')}}</span>
		</router-link>
	  </div>
	</header>
	<!-- z-body-bottom2 z-body-noscroll  -->
	<div class="z-body" :style="{height:(windowHeight-50)+'px'}">
		<div class="z-body-in">
	  <!-- 最新价格 -->
	  <div class="z-new">
		<div class="z-new-item z-new-item-1" :style="zfrateStyle">
		  <div>
			<span style="font-size: 30px;" v-text="last_price"></span>
			<span style="display:inline;">{{zfrate}}%</span>
		  </div>
		  <div>
		  	<!-- 跌 -->
			<img :src="require('../../assets/kline/'+kStyle.down.icon+'.png')" v-if="isDrop" />
			<!-- 涨 -->
			<img :src="require('../../assets/kline/'+kStyle.up.icon+'.png')" v-else />
		  </div>
		</div>
		<div class="z-new-item z-new-item-2 z-flex" style="flex-direction:column;">
		  <div>
			<span>{{$t('卖盘')}}</span>
			<span v-text="latelyData.sell_price"></span>
			<span></span>
			<span v-text="latelyData.sell_volume"></span>
		  </div>
		  <div>
			<span>{{$t('买盘')}}</span>
			<span v-text="latelyData.buy_price"></span>
			<span></span>
			<span v-text="latelyData.buy_volume"></span>
		  </div>
		  <div>
			<span>{{$t('最高')}}</span>
			<span v-text="latelyData.high_price"></span>
			<span></span>
			<span></span>
		  </div>
		  <div>
			<span>{{$t('最低')}}</span>
			<span v-text="latelyData.low_price"></span>
			<span></span>
			<span></span>
		  </div>
		</div>
		<!-- <div class="z-new-item z-new-item-2">
		  <div>
			<span>最高</span>
			<span v-text="high_price"></span>
			<span>最低</span>
			<span v-text="low_price"></span>
		  </div>
		  <div>
			<span>开盘</span>
			<span v-text="open_price"></span>
			<span>昨收</span>
			<span v-text="yestoday_settlement"></span>
		  </div>
		</div> -->
	  </div>
	  <!-- 选择类型 -->
	  <div class="z-flex z-Kline-times dark-color" style="position: relative;border-bottom: 1px solid #515151;">
	  	<!-- 时间线 -->
		<span v-for="(item,index) in timeArr" 
				v-if="item.is_more==0"
				@click="timeChooseEven(item)" 
				:class="item.type==chooseTimeType ? 'z-Kline-active' : ''"
				v-text="item.text">
		</span>
		<!-- 更多 -->
		<span @click="onShowMore" :class="timeArrMoreText!=$t('更多') ? 'z-Kline-active' : ''">
			<span v-text="timeArrMoreText"></span>
			<img src="../../assets/kline/more-2.png" v-if="timeArrMoreText!=$t('更多')" style="width:8px;height:8px;" />
			<img src="../../assets/kline/more-1.png" v-else  style="width:8px;height:8px;"/>
		</span>
		<div v-if="isShowMore" class="k-more-box">
		  <div 
		  	v-for="(item,index) in timeArr"
		  	v-if="item.is_more==1"
			:key="index" 
			@click="timeChooseEven(item)">{{item.text}}</div>
		</div>
	  </div>
	  <!-- 分时和k线 -->
	  <div style="position:relative;">
	  	<!-- K线图页面 -->
	  		<!-- K线均线价格 -->
			<div v-show="api=='1'" 
				class="z-flex kline-ma">
				MA<div style="color:#39afe6;">5：<span id="k-ma5"></span></div>
				<div style="color:#da6ee8;">10：<span id="k-ma10"></span></div>
				<div style="color:#ffab42;">20：<span id="k-ma20"></span></div>
				<div style="color:#00940b;">30：<span id="k-ma30"></span></div>
			</div>
		  	<div v-show="api=='1'" 
				  :style="{height: eh+'px'}" 
				  id="k-line" 
				  class="z-mk-line" 
				  @touchstart="kstart"
				  @touchmove="kmove"
				  @touchend="kend"
				  ></div>
		  <!-- 分时图页面 -->
		  <div v-show="api=='2'" 
				  	:style="{height: eh+'px'}" 
				  	id="m-line" 
				  	class="z-mk-line"></div>
	  </div>
	  

	  <!-- 加载动画 -->
	  <div v-if="isLoading" class="z-loading">
		<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
	  </div>

	  <!-- 按钮 -->
		<div class="z-kline-bottom">
	  <!-- 权益 -->
	  <div class="z-kline-qy" style="justify-content:space-between;">
		<div>{{$t('资产')}}：<span style="color:red;font-size:16px;" v-text="amount_before+mine.amount+amount_after"></span></div>
		
		<div>
			{{$t('当前价')}}：<span :style="zfrateStyle" v-text="last_price"></span>
		</div>
		<!-- <div>{{$t('杠杆倍数')}}：{{mine.lever}}{{$t('倍')}}</div> -->
		<!-- <div>可用：{{topDataAmount}}</div>
		<div>使用率：{{topDataUseRate}}%</div> -->
	  </div>
		<!-- 手数 -->
		<div class="z-kline-buy-select">
			<div>
				<img src="../../assets/kline/jian.png" style="margin-right:10px;" @click="buyNumsCalc(0)">
				<input type="number" v-model="buyNums" :placeholder="$t('请输入')+$t('手数')">
				<img src="../../assets/kline/jia.png" @click="buyNumsCalc(1)">
			</div>
			<div>
				<span>{{$t('手数')}}</span>
			</div>
		</div>
		
	  <!-- 选择 -->
	  <!-- <div class="z-kline-buy-select">
		<div>
		  <input v-show="buyModel==1" type="number" v-model="last_price" :placeholder="$t('请输入')+$t('市价')" readonly="">
		  <img v-show="buyModel==2" src="../../assets/kline/jian.png" style="margin-right:10px;" @click="price2Calc(0)">
		  <input v-show="buyModel==2" type="number" v-model="price2" :placeholder="$t('请输入')+$t('委托价')">
		  <img v-show="buyModel==2" src="../../assets/kline/jia.png" @click="price2Calc(1)">
		</div>
		<div @click="buyModelDialog=false">
		  <span v-show="buyModel==1">{{$t('市价')}}</span>
		  <span v-show="buyModel==2">{{$t('委托价')}}</span>
		  <span v-show="buyModel==3">{{$t('对手价')}}</span>
		  <img src="../../assets/kline/drop-down.png">
		</div>
	  </div> -->

	  <!-- 按钮 -->
	  <div class="z-kline-btns">
		<div @click="buy(1)" :style="{background:kStyle.up.color}">{{$t('买涨')}}</div>
		<div @click="buy(2)" :style="{background:kStyle.down.color}">{{$t('买跌')}}</div>
		<!-- <div @click="buy(3)">{{$t('平仓')}}</div> -->
		<div>
			<router-link style="width:100%;height:100%;display:block;" :to="getToken()==''?'/login': {path:'/futures/transaction',query:$route.query}">
			  <span style="color:#fff;">{{$t('平仓')}}</span>
			</router-link>
		</div>
	  </div>
	  
	</div>
	<!-- 逐笔 -->
	<div class="z-flex" :style="{flexDirection:'column',width:'100%',height: eh+'px'}">
  		<div class="zhubi-content" style="
            color: #ccc;
            ">
			<div>{{$t('成交时间')}}</div>
			<div>{{$t('成交价')}}</div>
			<div>{{$t('手数')}}</div>
		</div>
		<div style="overflow-y: scroll;margin:10px 0px;width: 100%;">
			<div class="zhubi-content zhubi-content-data" 
                v-for="(item,index) in zhubiList"
				:key="index"
				>
				<div v-text="item.timestamp"></div>
				<div v-text="item.pirce"></div>
				<div v-text="item.nums"></div>
			</div>
		</div>
  	</div>

	  <!-- 请选择购买类型 -->
	  <v-dialog v-model="buyModelDialog" scrollable max-width="300px">
		<div class="z-kline-buy-dialog">
		  <div>{{$t('请选择购买类型')}}</div>
		  <div :class="buyModel==1?'z-buy-model-select':''" @click="selectBuyModel(1)">
			{{$t('市价')}}
			<img v-if="buyModel==1" src="../../assets/index/sub-account/yes.png" class="z-icon" />
		  </div>
		  <div :class="buyModel==2?'z-buy-model-select':''" @click="selectBuyModel(2)">
			{{$t('委托价')}}
			<img v-if="buyModel==2" src="../../assets/index/sub-account/yes.png" class="z-icon" />
		  </div>
		  <div :class="buyModel==3?'z-buy-model-select':''" @click="selectBuyModel(3)">
			{{$t('对手价')}}
			<img v-if="buyModel==3" src="../../assets/index/sub-account/yes.png" class="z-icon" />
		  </div>
		  <div @click="buyModelDialog=false">{{$t('取消')}}</div>
		</div>
	  </v-dialog>

	  <!-- 弹出砍认框 -->
	  <v-dialog v-model="dialog.show" max-width="290">
		<v-card light>
		  <v-card-title class="headline">{{dialog.title}}</v-card-title>
		  <v-card-text>{{dialog.content}}</v-card-text>
		  <v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="green darken-1" flat="flat" @click="dialogCancel">{{$t('取消')}}</v-btn>
			<v-btn color="green darken-1" flat="flat" @click="dialogSuccess">{{$t('同意')}}</v-btn>
		  </v-card-actions>
		</v-card>
	  </v-dialog>

	  <!-- 下单确认弹框 -->
	  <v-dialog v-model="order.show" max-width="290">
		<v-card light>
		  <v-card-title class="headline">{{$t('确定交易')}}</v-card-title>
		  <v-card-text>
		  	<div style="margin-bottom:15px;">
		  		{{order.content}}
		  	</div>
		  	<!-- 用户设置止盈止损 2021-03-29客户要求去掉-->
			<!-- <div class="z-kline-buy-select">
				<div>
					<input type="number" v-model="win" :placeholder="$t('请输入')+$t('止盈')">
					%
				</div>
				<div>
					<span>{{$t('止盈')}}</span>
				</div>
			</div>
			<div class="z-kline-buy-select">
				<div>
					<input type="number" v-model="loss" :placeholder="$t('请输入')+$t('止损')">
					%
				</div>
				<div>
					<span>{{$t('止损')}}</span>
				</div>
			</div> -->
		  </v-card-text>
		  <v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="green darken-1" flat="flat" @click="orderCancel">{{$t('取消')}}</v-btn>
			<v-btn color="green darken-1" flat="flat" @click="orderYes">{{$t('同意')}}</v-btn>
		  </v-card-actions>
		</v-card>
	  </v-dialog>

	</div>
	</div>


	
</div>
</template>

<script>
  import {
	mInit,
	mAppend,
	kInit,
	kAppend,
	kShowTooltip
  } from "../../plugins/echarts.js";
  export default {
	name: "Kline",
	data() {
	  return {
	  	// 顶部当前价格和数量
	  	latelyData:{
	  		buy_price:0,// 买价
	  		buy_volume:0, // 买量
	  		sell_price:0,// 卖价
	  		sell_volume:0, // 卖量
	  		high_price:0, // 最高
	  		low_price:0 //最低
	  	},
	  	mine:{
	  		amount:0,
	  		lever:0,
	  	},
		isDrop: true,//true 跌  false涨
		stockName: "",
		timeArr: [ //K线时间类型数组，// 客户不要分时图，故隐藏
		 //  {
			// type: "0M",
			// text: this.$t('分时'),
			// is_more:0,
			// shishi_key:''
		 //  },
		  {
			type: "1M",
			text: "1"+this.$t('分'),
			is_more:0,
			shishi_key:'m1'
		  },
		  {
			type: "5M",
			text: "5"+this.$t('分'),
			is_more:0,
			shishi_key:'m5'
		  },
		  {
			type: "10M",
			text: "10"+this.$t('分'),
			is_more:0,
			shishi_key:'m10'
		  },
		  {
			type: "15M",
			text: "15"+this.$t('分'),
			is_more:0,
			shishi_key:'m15'
		  },
		  {
			type: "30M",
			text: "30"+this.$t('分'),
			is_more:1,
			shishi_key:'m30'
		  },
		  {
			type: "1H",
			text: this.$t('时')+"K",
			is_more:1,
			shishi_key:'h1'
		  },
		  {
			type: "D",
			text: this.$t('日')+"K",
			is_more:1,
			shishi_key:'d'
		  },
		  {
			type: "W",
			text: this.$t('周')+"K",
			is_more:1,
			shishi_key:''
		  },
		  {
			type: "M",
			text: this.$t('月')+"K",
			is_more:1,
			shishi_key:''
		  },
		],
		chooseTimeKey: "", // 当前k线key
		chooseTimeType: "1M", //默认K线时间类型
		chooseTimeText: this.$t('分时'), //默认K线时间类型文本
		isUpdateXaxis: false,
		fid: 0, //合约id
		isMain: 1, //1主力；0非主力
		api: 1, //1K线；2分时
		mIsFirst: true, //分时是否第一次加载，有加载过则不重复加载，只做数据追加，如果未加载，则加载
		kIsFirst: true, //K线是否第一次加载，有加载过则不重复加载，只做数据追加，如果未加载，则加载
		eh: 500, //图表高度
		mChart: null, //分时图表对象
		mOption: null, //分时图配置
		kChart: null, //K线图表对象
		kOption: null, //K线图配置
		isLoading: true, //是否加载中
		//最新价格
		cny: 0, //人民币
		zfrate: 0, //浮动比例
		sell_price: 0, //卖
		sell_volume: 0, //卖量
		buy_price: 0, //买
		buy_volume: 0, //买量
		position: 0, //持仓量
		volume: 0, // 成交量
		last_price: 0, //最新价
		close_price: 0, //收盘价
		high_price: 0, //开盘价
		open_price: 0, //最高价
		low_price: 0, //最低价
		yestoday_settlement: 0, //昨日结算价
		upOrDownVal: "", //涨跌,
		yc_p: "", //昨日持仓量
		SpanColor: "",
		//长连接-轮询检测
		eventInterval: null,
		colseEvent: null,
		mInterval: null,
		kInterval: null,
		//购买类型弹框
		buyModelDialog: false,
		//购买类型：1市价  2委托价 3对手价
		buyModel: 1,
		//购买方式：买涨  买跌
		buyType: 1,
		//市价
		price1: '',
		//委托价
		price2: '',
		price2Step: 0,
		// 购买总价
		buyTotalPrice:0,
		// 购买手数
		buyNums:1,
		//顶部当前权益信息
		topDataTotal: '',
		//顶部可用资金信息
		topDataAmount: '',
		//顶部使用率信息
		topDataUseRate: '',
		//长连接-轮询发送持仓请求
		holdInterval: null,
		//持仓轮询发送长连接
		holdSendLoop: null,
		//是否提交中
		is_submit_ing: 0,
		// 购买弹框
		dialog: {
		  show: false, //显示关态
		  type: null, //弹出类型
		  title: this.$t('你确定吗'),
		  content: this.$t('弹出说明文本'),
		  resolve: null, //创建的promise resolve函数
		  reject: null, //创建的promise reject
		  isConfirm: false //当前点击按钮类型 false为取消 true为确认
		},
		isShowMore: false,
		isShowZhubi: false,
		zhubiList:[],// 逐笔数据
		zhubiInterval:null, //逐笔轮询对象
		kMoveStatus:false,// k线移动状态
		kShowTooltipStatus:false,// k线弹框显示状态 false不显示  true显示
		kMoveIng:0,// K线是否在移动中 0没  1有
		kLongClickEvent:null,// K线长按事件
		kstart_time:0,//k线按下时间
		kend_time:0,//k线松开时间
		kstartX:0, //k线按下x轴坐标
		kstartY:0,//k线按下y轴坐标
		kTiaodongEnd:true,// k线最新实时跳动是否结束，只有结束了才能继续跳动
		kTiaodong:true,// k线最新实时跳动
		kTiaodongFirst:true,// k线最新实时跳动是否第一次
		timeArrMoreText:this.$t('更多'),// 更多具体文本
		zfrateStyle:{ //涨幅样式
			color:'#DF0712'
		},
		moniInterval:null,// 模拟数据轮询对象
		// 止盈比例
		win:0,
		// 止损比例
		loss:0,
		// 确认订单弹框
		order:{
			show:false,
			content:''
		},
		// mp
		mp:1,
		isComplete:true, //防止内存和cpu爆满
		
	  };
	},
	inject: ['reload'],
	// computed: {
	//   clacUpOrDownVal() { //最新价格
	// 	let val_1 = this.last_price - this.yestoday_settlement;
	// 	let val_2 = val_1 / this.yestoday_settlement;
	// 	return `${isNaN(val_1) ? 0 : val_1.toFixed(2)}/${
	// 			isNaN((val_2 * 100).toFixed(2)) ? 0 : (val_2 * 100).toFixed(2)
	// 		}%`;
	//   }
	// },
	created() {
	  let _this = this
	  //赋值
	  this.fid = this.$route.query.fid
	  // this.api = this.$route.query.api
	  // 客户不要分时图，故写死
	  this.api = 1
	  this.isMain = this.$route.query.is_main
	  this.stockName = this.$route.query.fname

	  _this.getMine()

	  //最新价格
	  // _this.getLastData()
	  _this.getPrice2CalcStep()
	  _this.getZhubiList()
	  
	},

	mounted() {
	  let _this = this;
	  if (_this.api == 1) { //K线
		_this.getKdata()
	  } else if (_this.api == 2) { //分时
		_this.getMdata()
	  }
	},
	destroyed() {
	  let _this = this;
	  clearInterval(_this.eventInterval)
	  clearInterval(_this.mInterval)
	  clearInterval(_this.kInterval)
	  clearTimeout(_this.colseEvent)
	  clearInterval(_this.holdInterval)
	  clearInterval(_this.holdSendLoop)
	  clearInterval(_this.zhubiInterval)
	  clearInterval(_this.moniInterval)
	},
	watch: {
	  'zfrate': function(newV) {
	    this.zfrate = newV
	    if (newV>=0) {
			  this.zfrateStyle = {
				color:this.kStyle.up.color
			}
		  this.isDrop = false
		} else {
			this.zfrateStyle = {
				color:this.kStyle.down.color
			}
		  this.isDrop = true
		}
		
	  },
	  '$store.state.webscoketObj.readyState': function(newV) { //监听长连接状态
		let _this = this
		_this.colseEvent = setTimeout(function() {
		  _this.reload()
		}, 1500)
	  },
	  '$route.query.api': function(newValue) {
		this.api = newValue
		if (newValue == 1) { //K线
		  if (this.kIsFirst) {
			this.getKdata()
		  }
		} else { //分时
		  if (this.mIsFirst) {
			this.getMdata()
		  }
		}
	  },
	  "$store.state.chooseTimeType": {
		handler: function(newType) {
		  let chooseTimeType = this.$store.state.chooseTimeType;
		  for (const item of this.timeArr) {
			if (chooseTimeType === item.type) {
			  this.chooseTimeText = item.text;
			  break;
			}
		  }
		},
		immediate: true
	  }
	},
	methods: {
		// 数据模拟
		moni:function (type,is_append) {
			return false;
			let _this = this
			// 请求步长(s)
			var step = 500;
			// 起步价格
			var basePrice = 39.5;
			// 起步数量
			var baseNums = 30;
			// 当前时间
			var now = new Date();
			// 时
			var h = now.getHours();
			// 分
			var m = now.getMinutes();
			// 间歇执行
			_this.moniInterval = setInterval(function() {
				// 分时
				if (type == '0M') {
					// 时间
					m++;
					if (m < 60) {
						var time = [h, m<10 ? '0'+m : m].join(':');
					}
					else {
						h = h+1
						m = '00';
						var time = [h, m].join(':');
					}

					// 数据
					var data = [
						time,// 时间
						basePrice+parseFloat(Math.random().toFixed(2)/10), // 最新价格
						basePrice+parseFloat(Math.random().toFixed(2)/10), // 均价
						parseInt(baseNums+m), // 成交量
					];
					// 是否追加
					if (is_append) {
						// 每秒执行一次
						mAppend(data)
					}
				}
			}, step);
		},
		// 当前实时key
		setChooseTimeKey:function () {
			let _this = this;
			_this.timeArr.forEach(function (item,key) {
				if (item.type == _this.chooseTimeType) {
					_this.chooseTimeKey = item.shishi_key;
				}
			});
		},
		// k线按下
		kstart:function (e) {
			var _this = this;
			// 关闭数据跳动
			_this.kTiaodong = false
			// 关闭更多弹框
	  		_this.isShowMore = false
			// 手指按下的坐标
			_this.kstartX = e.targetTouches[0].pageX;
			// 设置按下时间
			_this.kstart_time = new Date().getTime()
			// 创建长按事件
			_this.kLongClickEvent = setTimeout(function() {
				// 显示弹框
				kShowTooltip(true)
				// 弹框显示中
				_this.kShowTooltipStatus = true
				// console.log('k线按下 - 显示弹框')
			}, 600);
		},
		// k线移动
		kmove:function (e) {
			// 设置可以拉动
			e._isScroller = true
			let _this = this;
			// 移动了
			_this.kMoveStatus = true
			// 没达到长按
			if (!_this.kShowTooltipStatus) {
				// 清除长按事件
				clearTimeout(_this.kLongClickEvent);
				_this.kLongClickEvent = null;
				// 弹框关闭
				_this.kShowTooltipStatus = false
				// 关闭弹框
				kShowTooltip(false)
				// console.log('k线移动 - 关闭弹框')
			}

		},
		// k线松开
		kend:function (e) {
			let _this = this;
			// 设置松开时间
			_this.kend_time = new Date().getTime()
			// 短按
			if (!_this.kShowTooltipStatus || _this.kend_time - _this.kstart_time < 200) {
				// 开启数据跳动
				_this.kTiaodong = true
				// 清除长按事件
				clearTimeout(_this.kLongClickEvent);
				_this.kLongClickEvent = null;
				// 弹框关闭
				_this.kShowTooltipStatus = false
				// 关闭弹框
				kShowTooltip(false)
				// console.log('k线松开 - 关闭弹框')
			}
			// 在没有显示弹框的情况
			if (!_this.kShowTooltipStatus) {
				// 手指松开的坐标
				let kendX = e.changedTouches[0].pageX;
				// 右->左
				if (_this.kstartX > kendX) 
				{
					_this.kTiaodong = true
				}
				// 左->右
				else 
				{
					_this.kTiaodong = false
				}
			}
			
		},
		// 获取逐笔数据
		getZhubiList:function () {
			let _this = this;
			_this.get('api/Quotations/ticks', {fid:_this.fid,limit:30}).then((res) => {
				if (res.code == 0) {
					_this.zhubiList = res.data
				}
			})
		},
		// 个人信息
		getMine:function () {
			let _this = this
			//会员信息
			this.get('api/users/center', {}).then((res) => {
				if (res.code == 0) {
					this.mine = res.data
					this.win = this.mine.win
					this.loss = this.mine.loss
					
				}
			})
		},
		// 设置最大手数
		setMaxBuyNums(){
			let _this = this
			setTimeout(function () {
				// 设置最大手数
				_this.buyNums = _this.last_price > 0 ? Math.floor(_this.zmath.div(_this.mine.amount,_this.last_price) * 1000) / 1000 : 0.0001;
				// _this.buyNums = _this.last_price > 0 ? parseInt(_this.zmath.div(_this.mine.amount,_this.last_price)) : 1;
			},100)
			
		},
	  //委托价 加/减
	  price2Calc(type) {
		let _this = this,
		  s = _this.price2Step,
		  o = _this.price2,
		  n = type ? _this.zmath.add(o, s) : _this.zmath.sub(o, s);
		if (n < 0) {
		  _this.$store.commit('layer', _this.$t('委托价不能低于')+0)
		}
		_this.price2 = n
	  },
	  //手数 加/减
	  buyNumsCalc(type) {
		let _this = this,
		  s = 1,
		  o = _this.buyNums,
		  n = type ? _this.zmath.add(o, s) : _this.zmath.sub(o, s);
		  // 手数不能小于0
		if (n < 0) {
		  _this.$store.commit('layer', _this.$t('手数低于')+0)
		  return false
		}
		// 赋值
		_this.buyNums = Math.floor(n * 1000) / 1000
		// 总价不能大于用户资产
		_this.clacBuyTotalPrice()
		if (_this.mine.amount < _this.buyTotalPrice) {
			_this.buyNums = Math.floor((n - 1) * 1000) / 1000
			_this.$store.commit('layer', _this.$t('资产不足'))
		  	return false
		}
		
	  },
	  
	  //获取委托 加/减 步长
	  getPrice2CalcStep() {
		this.get('api/Futures/variable_price', {
		  id: this.fid
		}).then((rs) => {
		  this.price2Step = parseFloat(rs.data)
		})
	  },
	  // 选择价格类型
	  selectBuyModel(type) {
		if (type == 2) {
		  this.price2 = this.last_price
		}
		this.buyModel = type
		this.buyModelDialog = false
	  },
	  //最新价格 - 数据
	  getLastData() { 
		let _this = this;
		let fid = _this.$route.query.fid
		_this.get('api/hangqing/getLately', {
			fid: fid
		  })
		  .then(function(rs) {
			if (rs.code == 0) {
			  _this.setLastData(rs.data)
			  _this.price2 = rs.data.last_price
			  // console.log(rs.data.m1)
			  kAppend(rs.data.m1.split(','));
			}
		  })
		  .catch(function(err) {

		  });
	  },
	  //最新价格 - 设置数据格式
	  setLastData(data) { 
		let _this = this
		// 设置最新数据
		_this.latelyData = data
		for (const key in data) {
		  if (_this.hasOwnProperty(key)) {
			_this[key] = data[key]
			// 设置最大手数
			if (key == 'last_price') {
				_this.setMaxBuyNums()
			}
	  		
		  }
		}
	  },
	  //设置图表div高度
	  setEchartsBoxHeight(elId) { 
		let _this = this
		let h = document.body.clientHeight
		_this.eh = h - 320
		//_this.eh = h-20
		let el = document.getElementById(elId)
		let son = el.getElementsByTagName('div')[0]
		son.style.height = '100%'
		son.style.width = '100%'
		let canvas = son.getElementsByTagName('canvas')[0]
		canvas.style.height = '100%'
		canvas.style.width = '100%'
	  },
	  //获取分时数据
	  getMdata() { 
		let _this = this;
		//显示加载
		_this.isLoading = true
		//异步数据
		_this.get('api/Quotations/minute', {
			fid: this.$route.query.fid
		  })
		  .then(function(rs) {
			if (rs.code == 0) {
			  _this.$nextTick(() => {
				//设置非一次
				_this.mIsFirst = false
				//图表初始化
				_this.mChart = mInit(_this,rs.data)

				//设置宽高
				_this.setEchartsBoxHeight('m-line')

				//隐藏加载
				_this.isLoading = false

				//发送长连接
				_this.wsSend()

			  })
			} else {
			  //隐藏加载
			  _this.isLoading = false
			}
		  })
		  .catch(function(err) {
			//隐藏加载
			_this.isLoading = false

		  })

	  },
	  //获取K线数据
	  getKdata() { 
		let _this = this;
		//显示加载
		_this.isLoading = true
		//异步数据
		_this.get('api/Quotations/Line', {
			fid: _this.$route.query.fid,
			period: _this.chooseTimeType
		  })
		  .then(function(rs) {
			if (rs.code == 0 && rs.data.length > 0) {
			  _this.$nextTick(() => {
				//设置非一次
				_this.kIsFirst = false
				//图表初始化
				kInit(_this,rs.data)
				//设置宽高
				_this.setEchartsBoxHeight('k-line')
				//隐藏加载
				_this.isLoading = false
				//发送长连接
				_this.wsSend()
				// 开启跳动
		  		_this.kTiaodong = true
			  	// 设置跳动结束，可以开始新的跳动
			  	_this.kTiaodongEnd = true
			  	// 重设第一次跳动
			  	_this.kTiaodongFirst = true
			  })
			} else {
			  //隐藏加载
			  _this.isLoading = false
			}
			// 获取最新价
			_this.getLastData()
		  })
		  .catch(function(err) {
			//隐藏加载
			_this.isLoading = false
		  })
	  },
	  timeChooseEven(item) { //K线时间类型选择
	  	let _this = this
	  	// 关闭更多弹框
	  	_this.isShowMore = false
	  	// 更多文本
		if (item.is_more) 
		{
		  _this.timeArrMoreText = item.text
		}
		else {
			_this.timeArrMoreText = _this.$t('更多')
		}
		// 设置选文本和类型
		_this.chooseTimeText = item.text
		_this.chooseTimeType = item.type
		// 请求数据
		if (item.type == '0M') {
		  _this.api = 2
		  _this.getMdata()
		} else {
		  _this.api = 1
		  _this.getKdata()
		}
	  },
	  wsSend() { //长连接 - 发送(分时、K线、最新价格默认都传)
		let _this = this
		let request = JSON.stringify({
		  action: 'Futures',
		  data: {
			token: _this.getToken(),
			list: _this.$route.query.code,
			period: _this.api == 2 ? '0M' : _this.chooseTimeType
		  }
		})
		//长连接状态正常才发送
		if (_this.$store.state.webscoketObj && _this.$store.state.webscoketObj.readyState == 1) {
		  clearInterval(_this.eventInterval)
		  _this.$store.state.webscoketObj.send(request)
		  _this.$store.state.webscoketObj.onmessage = _this.wsReceive
		} else { //长连接状态不正常，则轮询
		  _this.eventInterval = setInterval(function() {
			clearInterval(_this.eventInterval)
			_this.wsSend()
		  }, 1000)
		}
	  },
	  wsReceive(e) { //长连接 - 接收
		let _this = this
		let rs = JSON.parse(e.data)
		let data = rs.data
		if (rs.type == 'minute') { //分时 - 追加,格式：{"data":JSON.stringify({"type":"minute","data":["09:13","1488.59998","1489.19702","57"]})}
		  mAppend(data)
		} else if (rs.type == 'line') { //K线 - 追加，格式：{"data":JSON.stringify({"type":"line","data":["19/12/25 17:30", 14580, 15080, 14880, 14980, 552]})}
		  if (_this.chooseTimeType == '1M' ||
			_this.chooseTimeType == '5M' ||
			_this.chooseTimeType == '10M' ||
			_this.chooseTimeType == '30M' ||
			_this.chooseTimeType == '1H') {
		  	// 防止CPU和内存溢出
			// if (!_this.isComplete) {
			// 	return false;
			// }
			// _this.isComplete = false
			// setTimeout(function () {
			// 	_this.isComplete = true
			// },300)

			kAppend(data)

		  	// if (_this.kTiaodongFirst) {
		  	// 	if (kAppend(data,true)) {
		  	// 		_this.kTiaodongFirst = false
		  	// 	}
		  	// }
		  	// else {
		  	// 	if (kAppend(data,false)) {
		  	// 		_this.kTiaodongFirst = true
		  	// 	}
		  	// }
		  }
		} else if (rs.type == 'hangqing') { //最新价格
		  let fid = _this.$route.query.fid
		  data.forEach(function(item, index) {
		  	// console.log('fid='+fid +'=='+ 'item.fid='+item.fid)
		  	// 当前合约
			if (fid == item.fid) {
				// 防止CPU和内存溢出
				// if (!_this.isComplete) {
				// 	return false;
				// }
				// _this.isComplete = false
				// setTimeout(function () {
				// 	_this.isComplete = true
				// },300)

				// 数据跳动
				_this.setChooseTimeKey()
				// console.log("_this.kTiaodongEnd=")
				// console.log(_this.kTiaodongEnd)
				// console.log("_this.kTiaodong=")
				// console.log(_this.kTiaodong)
				// console.log("_this.chooseTimeKey=")
				// console.log(_this.chooseTimeKey)
				// console.log('item.hasOwnProperty(_this.chooseTimeKey)=')
				// console.log(item.hasOwnProperty(_this.chooseTimeKey))
				
				if (item.hasOwnProperty(_this.chooseTimeKey)) {
					let kAppendData = item[_this.chooseTimeKey].split(',');
					kAppend(kAppendData)
				}


				// if (_this.kTiaodongEnd &&
				// 	 _this.kTiaodong && 
				// 	 _this.chooseTimeKey && 
				// 	 item.hasOwnProperty(_this.chooseTimeKey)) {
				// 	// console.log('-----')
				// 	// 设置k线跳动未结束
				// 	_this.kTiaodongEnd = false
				// 	// k线跳动数据处理
				// 	let kAppendData = item[_this.chooseTimeKey].split(',');
				// 	// 第一次跳动，则追加
				// 	if (_this.kTiaodongFirst) {
				//   		if (kAppend(kAppendData,true)) {
				//   			// 设置k线跳动结束
				// 			_this.kTiaodongEnd = true
				//   			_this.kTiaodongFirst = false
				//   		}
				//   		else {
				//   			// 设置k线跳动结束
				// 			_this.kTiaodongEnd = true
				//   		}
				//   	}
				//   	else {
				//   		if (kAppend(kAppendData,false)) {
				//   			// 设置k线跳动结束
				// 			_this.kTiaodongEnd = true
				//   		}
				//   		else {
				//   			// 设置k线跳动结束
				// 			_this.kTiaodongEnd = true
				//   		}
				//   	}
				// }
				// 逐笔数据追加
			  	if (item.ts) {
			  		_this.zhubiList.unshift(item.ts)
			  	}
			  _this.setLastData(item)
			}
		  })
		}
		else if (rs.type == 'init') { //绑定cliend_id
			_this.get('api/users/bindclientid', {client_id:data.client_id})
		}

		
	  },
	  //持仓数据【作废】
	  holding() {
	  	return false
		let _this = this
		_this.post('api/Trade/Holding.html', {}).then((rs) => {
		  if (rs.code == 0) {
			// _this.topDataTotal = rs.data.money.total //权益
			// _this.topDataAmount = rs.data.money.amount //可用
			// _this.topDataUseRate = rs.data.money.useRate //使用率
		  }
		})
	  },
	  // 显示购买总价
		clacBuyTotalPrice(){
			let _this = this 
			// 市价 || 对手价
			if (_this.buyModel == 1 || _this.buyModel == 3) {
				_this.buyTotalPrice = _this.zmath.mul(_this.last_price,_this.buyNums)
				//
			}
			// 委托价
			else if (_this.buyModel == 2) {
				_this.buyTotalPrice = _this.zmath.mul(_this.price2,_this.buyNums)
			}

		},
		// 订单取消
		orderCancel(){
			this.order.show = false
		},
		// 订单提交
		orderYes(){
			let _this = this
			this.is_submit_ing = 1
			  // 单价
			  let price = _this.last_price
				if (_this.buyModel == 2) {
				  price = _this.price2
				  if (!_this.price2) {
					_this.$store.commit('layer', _this.$t('请输入')+_this.$t('委托价'))
					return false
				  }
				}
			  // 买涨(做多1) / 买跌(做空2)
			  if(_this.mp == 1 || _this.mp == 2){
			  	this.post('api/trade/DownOrder', {
					fid: this.fid,
					btype: this.buyModel, //1:市价 2委托价 3对手价
					price: price,
					hand_num:_this.buyNums,
					mp: _this.mp,
					win: this.win,
					loss: this.loss,
				}).then((res) => {
					this.is_submit_ing = 0
					this.getMine()
					this.$store.commit('layer', res.msg)
					this.orderCancel()
				})
			  }
			  // 平仓3
			  else {
			  	this.post('api/Trade/closed', {
					fid: this.fid,
					price: price,
					hand_num:_this.buyNums,
					win: this.win,
					loss: this.loss,
				}).then((res) => {
					this.is_submit_ing = 0
					this.$store.commit('layer', res.msg)
					this.orderCancel()
				})
			  }
		},
		// 订单弹框(买涨(做多1) / 买跌(做空2) / 平仓3)
		buy(mp) {
			let _this = this
			if (_this.buyNums<=0) {
				_this.$store.commit('layer', _this.$t('手数')+_this.$t('不能小于')+" 0")
				return false
			}
			_this.mp = mp
			let price = _this.last_price
			if (_this.buyModel == 2) {
			  price = _this.price2
			  if (!_this.price2) {
				_this.$store.commit('layer', _this.$t('请输入')+_this.$t('委托价'))
				return false
			  }
			}
			// 计算总价
			_this.clacBuyTotalPrice()
			if (_this.mine.amount == 0 || _this.mine.amount < _this.buyTotalPrice) {
				_this.$store.commit('layer', _this.$t('资产不足'))
			  	return false
			}
			let typeText = ""
			if (mp == 1) {
			  typeText = _this.$t('买涨')
			} else if (mp == 2) {
			  typeText = _this.$t('买跌')
			}
			else if (mp == 3) {
			  typeText = _this.$t('平仓')
			}
			// 计算总价
			_this.clacBuyTotalPrice()
			// 显示内容
			// _this.order.content = typeText + ': ' + this.stockName +'， ' + _this.$t('手数') + '：'+ this.buyNums + '， ' + _this.$t('价格') + '：'+ _this.$t('约') + this.amount_before + _this.buyTotalPrice + this.amount_after;
			_this.order.content = typeText + ': ' + this.stockName +'， ' + _this.$t('手数') + '：'+ _this.buyNums + '， ' + _this.$t('价格') + '：'+ this.amount_before + _this.last_price + this.amount_after;
			// 显示弹框
			_this.order.show = true
		},
	  // 作废：买涨(做多1) / 买跌(做空2) / 平仓3
	  buy22(mp) {
	  	let _this = this
		let price = _this.last_price
		if (_this.buyModel == 2) {
		  price = _this.price2
		  if (!_this.price2) {
			_this.$store.commit('layer', _this.$t('请输入')+_this.$t('委托价'))
			return false
		  }
		}
		// 计算总价
		_this.clacBuyTotalPrice()
		if (_this.mine.amount < _this.buyTotalPrice) {
			_this.$store.commit('layer', _this.$t('资产不足'))
		  	return false
		}
		// 弹框
		this.showDialog(this.dialogOpt(mp)).then(() => {
		  this.is_submit_ing = 1
		  // 单价
		  let price = _this.last_price
			if (_this.buyModel == 2) {
			  price = _this.price2
			  if (!_this.price2) {
				_this.$store.commit('layer', _this.$t('请输入')+_this.$t('委托价'))
				return false
			  }
			}
		  // 买涨(做多1) / 买跌(做空2)
		  if(mp == 1 || mp == 2){
		  	this.post('api/trade/DownOrder', {
				fid: this.fid,
				btype: this.buyModel, //1:市价 2委托价 3对手价
				price: price,
				hand_num:_this.buyNums,
				mp: mp,
				win: this.win,
				loss: this.loss,
			}).then((res) => {
				this.is_submit_ing = 0
				this.getMine()
				this.$store.commit('layer', res.msg)
			})
		  }
		  // 平仓3
		  else {
		  	this.post('api/Trade/closed', {
				fid: this.fid,
				price: price,
				hand_num:_this.buyNums,
				win: this.win,
				loss: this.loss,
			}).then((res) => {
				this.is_submit_ing = 0
				this.$store.commit('layer', res.msg)
			})
		  }
		  
		}).catch(() => {
		  this.is_submit_ing = 0
		});
	  },
	  // 作废：显示弹出框
	  dialogOpt(type) {
	  	let _this = this
		let typeText = ""
		if (type == 1) {
		  typeText = _this.$t('买涨')
		} else if (type == 2) {
		  typeText = _this.$t('买跌')
		}
		else if (type == 3) {
		  typeText = _this.$t('平仓')
		}
		// 计算总价
		_this.clacBuyTotalPrice()
		// 显示内容
		let content = typeText + ': ' + this.stockName +'， ' + _this.$t('手数') + '：'+ this.buyNums + '， ' + _this.$t('价格') + '：'+ _this.$t('约') + this.amount_before + _this.buyTotalPrice + this.amount_after;
		return {
		  title: _this.$t('确定交易')+"?",
		  content: content
		}
	  },
	  // 作废：
	  showDialog(opts) {
		return new Promise((resolve, reject) => {
		  this.dialog.show = true;
		  this.dialog.title = opts.title;
		  this.dialog.content = opts.content;
		  this.dialog.resolve = resolve;
		  this.dialog.reject = reject;
		});
	  },
	  // 作废：
	  closeDialog() {
		//重置
		this.dialog.show = false;
		this.dialog.title = null;
		this.dialog.content = null;
		this.dialog.resolve = null;
		this.dialog.reject = null;
	  },
	  // 作废：
	  dialogSuccess() {
		this.dialog.resolve();
		this.closeDialog();
	  },
	  // 作废：
	  dialogCancel() {
		this.dialog.reject();
		this.closeDialog();
	  },
	  onShowMore() {
		this.isShowMore = !this.isShowMore
	  },
	  onShowZhubi() {
		this.isShowZhubi = !this.isShowZhubi
		if (this.isShowZhubi) {
			// 逐笔
	  		this.getZhubiList();
		}
	  }
	}
  };
</script>

<style scoped>
  .z-Kline-header {
	height: 60px;
	font-size: 18px;
	color: white;
	padding: 0 10px;
	justify-content: space-between;
	background-color: #28293D;
	border-bottom: 1px solid #424355;
  }

  .z-echarts-box {
	overflow: hidden;
	height: 100%;
  }

  /* 最新价格 start*/
  .z-new {
	position: relative;
	display: flex;
	display: -webkit-flex;
	justify-content: flex-start;
	background-color: #20232A;
	width: 100vw;
	height: 80px;
	padding: 10px 0px;
	border-bottom: 1px solid #1E1F22;
  }

  .z-new-item {
	width: 50%;
  }

  .z-new-item img {
	width: 25px;
	height: 25px;
  }

  .z-new-item-1 {
	display: flex;
	display: -webkit-flex;
	justify-content: center;
  }

  .z-new-item-1 div:first-child {
	display: flex;
	display: -webkit-flex;
	flex-direction: column;
	text-align: center;
  }

  .z-new-item-1 div:nth-child(2) {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	width: 20%;
  }

  .z-new-item-2 div {
	display: flex;
	display: -webkit-flex;
	flex-direction: row;
	justify-content: space-around;
	color: #898989;
	font-size: 12px;
	width: 100%;
	padding: 1px 0px;
  }

  .z-new-item-2 div>span:nth-child(1),
  .z-new-item-2 div>span:nth-child(3) {
	width: 20%;
  }

  .z-new-item-2 div>span:nth-child(2),
  .z-new-item-2 div>span:nth-child(4) {
	width: 30%;
  }

  /* 最新价格 end*/

  /* 分时图和K线图高度 START*/
  .z-mk-line {
	width: 100%;
	touch-action: pan-y;
	user-select: none;
	-webkit-user-drag: none;
	/* padding-bottom: 60px; */
  }

  .z-loading {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0px;
	left: 0px;
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: center;
  }

  /* 分时图和K线图高度 END*/


  .hearIcon {
	width: 20px;
	height: 20px;
  }

  .time-choose-menu {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
  }

  .time-choose-menu p {
	margin: 0;
	width: 100%;
	text-align: center;
	height: 25px;
  }

  .z-Kline-times {
	height: 30px;
	color: #9B9A99;
	font-size: 14px;
	padding: 10px;
  }

  .z-Kline-active {
	color: #E2B96F;
	border-bottom: 3px solid #E2B96F;
  }

  .z-Kline-trade {
	background: #21222B;
	padding: 10px;
	justify-content: center;
	font-size: 18px;
	border-top: 1px solid #282932;
	height: 47px;
	width: 100%;
  }

  .z-Kline-trade img {
	width: 20px;
  }

  /* 权益 */
  .z-kline-qy {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: space-around;
	background: #20232A;
	padding: 10px;
	margin-bottom: 10px;
  }

  /* 选择 */
  .z-kline-buy-select {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: space-around;
	border: 1px solid #6B6B6B;
	width: 90%;
	margin: 0 auto;
	padding: 8px 5px;
	border-radius: 5px;
	margin-bottom: 15px;
  }

  .z-kline-buy-select div:nth-child(1) input {
	width: 60%;
	outline: none;
  }

  .z-kline-buy-select div:nth-child(1) {
	border-right: 1px solid #6B6B6B;
	display: flex;
	display: -webkit-flex;
	align-items: center;
  }

  .z-kline-buy-select div:nth-child(1) img {
	width: 20px;
	height: 20px;
  }

  .z-kline-buy-select div:nth-child(2) {
	text-align: center;
	width: 30%;
  }

  .z-kline-buy-select div:nth-child(2) img {
	width: 10px;
	height: 10px;
  }

  .z-kline-buy-dialog {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: space-around;
	flex-direction: column;
	background: white;
	width: 100%;
	color: #282834;

  }

  .z-kline-buy-dialog div {
	padding: 8px;
	width: 80%;
	text-align: center;
  }

  .z-kline-buy-dialog img {
	width: 10px;
	height: 10px;
  }

  .z-kline-buy-dialog div:nth-child(1),
  .z-kline-buy-dialog div:last-child {
	color: #ABABAB;
  }

  .z-kline-buy-dialog div:last-child {
	text-align: right;
  }

  .z-buy-model-select {
	color: #E2B96F;
  }

  /* 按钮 */
  .z-kline-btns {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: space-between;
	width: 90%;
	margin: 10px auto;
  }

  .z-kline-btns div {
	width: 30%;
	border-radius: 5px;
	text-align: center;
	padding: 10px;
	margin-right: 10px;
  }

  .z-kline-btns div:nth-child(1) {
	color: #fff;
  }

  .z-kline-btns div:nth-child(2) {
	color: #fff;
  }
  .z-kline-btns div:nth-child(3) {
	background: #c2c2c2;
	color: #fff;
  }

  .z-kline-bottom {
	/*position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;*/
	background: #20232A;
	color: #fff;
	border-top: 1px solid #515151;
	border-bottom: 1px solid #515151;
  }
/*逐笔*/
.zhubi-content {
	width: 100%;
	font-size: 12px;
	color:#999999;
}
.zhubi-content div{
	width: 33%;
	float: left;
	text-align: center;
}
.zhubi-content-data div:nth-child(2){
	color:#365AE1;
}
.kline-ma {
	padding: 5px 10px;
	font-size: 12px;
}
/*更多弹框*/
.k-more-box {
	position: absolute;top: 40px;right: 0;display: flex;flex-direction: column;z-index: 999;background: #000;color: #fff;opacity:0.7;filter:alpha(opacity=70);
}
.k-more-box div{
width: 100px;display: flex;align-items: center;justify-content: center;margin-bottom: 2px;height:38px;border-bottom:1px solid #cccccc;
}
.k-more-box div:last-child {
	border-bottom:0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/futures/kline.vue